<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header text-center">
          <p class="h4  float-left">Lista Productos</p>
          <a (click)="createProduct()" class="btn btn-success float-right">
            Crear Producto</a
          >
        </div>
        <div class="card-body">
          <input
            class="form-control"
            #searchTerm
            (keyup)="search(searchTerm.value)"
            placeholder="Buscando productos..."
          />
          <div *ngIf="productos && !productService.isLoading">
            <table
              class="table-bordered table-condensed"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>Codigo</th> 
                  <th>Nombre</th>
                  <th>U.M</th>
                  <th>Precio Venta</th>
                  <th>Categoría</th>
                  <th>Habilitado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody *ngFor="let product of productos.data; let i = index">
                <tr>
                  <th scope="row">
                    {{
                      i + 1 + (productos.current_page - 1) * productos.per_page
                    }}
                  </th>
                  <td>
                    {{product.codigo}}
                  </td>
                  <!-- <td>
                    <img
                      height="50"
                      width="50"
                      [src]="imageURL + product.foto"
                      alt=""
                    />
                  </td> -->
                  <td>{{ product.nombre }}</td>
                  <td>{{ product.unidad.abreviado }}</td>
                  <td>{{ product.precio_venta }}</td>
                  <td>{{ product.categoria.nombre }}</td>
                  <td>
                    <label
                      class="switch switch_type1"
                      role="switch"
                      *ngIf="product.habilitado == true"
                    >
                      <input
                        type="checkbox"
                        class="switch__toggle"
                        (click)="enableProduct(product.producto_id)"
                        checked="false"
                      />
                      <span class="switch__label"></span>
                    </label>
                    <label
                      class="switch switch_type1"
                      role="switch"
                      *ngIf="product.habilitado == false"
                    >
                      <input
                        type="checkbox"
                        class="switch__toggle"
                        (click)="enableProduct(product.producto_id)"
                      />
                      <span class="switch__label"></span>
                    </label>
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-default btn-lg"
                      (click)="editModal(product.producto_id)"
                    >
                      <i
                        class="fa fa-pencil-square-o text-info"
                        style="font-size: 25px"
                      ></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <p>
              Mostrando Productos {{ productos.from }} a {{ productos.to }} de
              {{ productos.total }}
            </p>
            <p>
              Página {{ productos.current_page }} de {{ productos.last_page }}
            </p>

          
              <input type="number" style="width: 50px;"
                 [(ngModel)]="paginanum" name="home" required min="0" step="1">
                 <button (click)="searchPage(paginanum)" >
                  ir
                </button>
           <br>

            <button (click)="prevPage()" [disabled]="!productos.prev_page_url">
              Anterior
            </button>
            <button (click)="nextPage()" [disabled]="!productos.next_page_url">
              Siguiente
            </button>

          </div>
          <p *ngIf="productService.isLoading">Cargando...</p>

          
        </div>
      </div>
    </div>
  </div>
</div>
